import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IndexComponent} from "./index.component";
import {ViewModule} from "../views/view.module";

@NgModule({
  imports: [
    CommonModule,
	  ViewModule
  ],
  declarations: [
  	IndexComponent
  ],
})
export class IndexModule { }
